var styleDataHash = "378fc270";
const injectCss = (() => {
  var css = `.wyb8n{margin-left:0;margin-right:auto;z-index:1}.wyb8n:not(._74xUB){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.wyb8n:not(._74xUB){float:none;margin-right:auto}}}@container (width < 480px){.wyb8n:not(._74xUB){float:none;margin-right:auto}}._4B4GZ{margin-left:auto;margin-right:0;z-index:1}._4B4GZ:not(._74xUB){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){._4B4GZ:not(._74xUB){float:none;margin-left:auto}}}@container (width < 480px){._4B4GZ:not(._74xUB){float:none;margin-left:auto}}.ds0-4{clear:both;display:block}.ds0-4:not(.BiWj2){margin-left:auto;margin-right:auto;max-width:100%}.BiWj2,._74xUB{width:100%}.OBE6r .BiWj2,.OBE6r ._74xUB{margin:0 -8px;width:auto}.xlzdN{width:fit-content}.yeCcR{margin-left:auto;margin-right:auto;max-width:100%}.bEEnh{width:min(350px,100%)!important}.OBE6r .bEEnh{width:50%}.lxUGd{margin-left:auto;margin-right:auto}.OBE6r .lxUGd{width:150px}.XE0ne{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "alignLeft": "wyb8n",
  "textWrapNowrap": "_74xUB",
  "alignRight": "_4B4GZ",
  "alignCenter": "ds0-4",
  "sizeFullWidth": "BiWj2",
  "renderedInTable": "OBE6r",
  "sizeOriginal": "xlzdN",
  "sizeContent": "yeCcR",
  "sizeSmall": "bEEnh",
  "sizeSmallCenter": "lxUGd",
  "flex": "XE0ne"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
